import { lazy } from 'react';

// Lazy load page components
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Pricing = lazy(() => import('./pages/Pricing'));
const PowerOutage = lazy(() => import('./pages/PowerOutage'));
const DistributionBoard = lazy(() => import('./pages/DistributionBoard'));
const Renovatie = lazy(() => import('./pages/Renovatie'));
const CookingGroup = lazy(() => import('./pages/CookingGroup'));
const Binnenverlichting = lazy(() => import('./pages/Binnenverlichting'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Admin pages
const AdminLogin = lazy(() => import('./pages/admin/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const AdminRedirect = lazy(() => import('./pages/admin/AdminRedirect'));

// Routes configuration
const routes = [
  {
    path: '/',
    element: Home,
  },
  {
    path: '/about',
    element: About,
  },
  {
    path: '/contact',
    element: Contact,
  },
  {
    path: '/pricing',
    element: Pricing,
  },
  {
    path: '/stroomstoringen',
    element: PowerOutage,
  },
  {
    path: '/groepenkast',
    element: DistributionBoard,
  },
  {
    path: '/renovatie',
    element: Renovatie,
  },
  {
    path: '/kookgroep',
    element: CookingGroup,
  },
  {
    path: '/binnenverlichting',
    element: Binnenverlichting,
  },
  {
    path: '/admin',
    element: AdminRedirect,
  },
  {
    path: '/admin/login',
    element: AdminLogin,
  },
  {
    path: '/admin/dashboard',
    element: AdminDashboard,
    protected: true,
  },
  {
    path: '*',
    element: NotFound,
  },
];

export default routes;
